import React from 'react'
import '../assets/css/Table.css'
import '../assets/dmgAssets/css/UserSearch.css';
import Input from '../DMGComponents/Input'
import Button from '../DMGComponents/Button'
import { getAdHocUsersForArea, addAdHocAreaUser, removeAdHocAreaUser, sendAdHocUserMailAll, sendAdHocUserMail, addAdHocAreaUsers } from '../fetchData';
import Break from '../DMGComponents/Break'
import toast, { Toaster } from 'react-hot-toast';
import { withRouter } from 'react-router-dom';
import UserManagementIcon from '../assets/img/people-fill.svg'; 
import CopyLinkIcon from '../assets/img/copy-clipboard-bg.svg';
import { validateEmail } from '../utils/helperFunctions';
import AdHocAddMultipleUsers from '../components/AdHocAddMultipleUsers'
import ReactSpinner from 'react-bootstrap-spinner';

class AdHocUserManagement extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            searchText: "",
            searchUserResult: [],
            checked: [],
            isSearching: false,
            noResult: false,
            selectedUser: [],
            checked: [],
            areaUsers: [],
            selectedAreaId: this.props.areaId,
            selectedAreaStatus: this.props.areaStatus,
            adHocEmail: '',
            adHocValidationError: "",
            adHocLink: "",
            adHocId: '',
            showMultiInput: false,
            isLoading: false
        }
        this.loadAreaUsers = this.loadAreaUsers.bind(this);
        this.adHocEmailChanged = this.adHocEmailChanged.bind(this);
        this.openMultiInput = this.openMultiInput.bind(this);
        this.closeMultiInput = this.closeMultiInput.bind(this);
    }

    componentDidMount() {
        this.loadAreaUsers(this.props.areaId);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.areaId !== this.props.areaId) {
            this.setState({ selectedAreaId: this.props.areaId });
            this.loadAreaUsers(this.props.areaId);
        }
    }

    openMultiInput = () => {
        this.setState({ showMultiInput: true });
    };

    closeMultiInput = () => {
        this.setState({ showMultiInput: false });
    };

    loadAreaUsers = (areaId) => {
        if (areaId != null) {
            this.setState({
                isSearching: true,
                areaUsers: [],
                isLoading: true,
            })
            getAdHocUsersForArea(areaId).then((res) => {
                let arr = []
                res.forEach(u => {
                    arr.push({ email: u.email, adHocId: u.adHocId })
                });
                this.setState({
                    areaUsers: arr,
                    isSearching: false,
                    isLoading: false,
                })
            }).catch((err) => {
                this.setState({ isLoading: false });
                console.error("Error", err)
            })
        }
    }

    addUser = () => {
        this.setState({
            adHocValidationError: ""
        })
        if (this.state.adHocEmail.length > 3 && validateEmail(this.state.adHocEmail)) {
            let user = { email: this.state.adHocEmail };
            var currUsers = this.state.areaUsers;
            var checkIfUserInList = currUsers.findIndex(object => {
                return object.email === user.email;
            });
            if (checkIfUserInList === -1) {
                this.addUserToArea(user)
            }
        }
        else {
            this.setState({
                adHocValidationError: "Please enter a valid email address."
            })
        }
    };

    addMultipleUsers = (emailsToAdd) => {
        let usersToAddWithoutDuplicates = []
        let currUsers = this.state.areaUsers;
        for (let i = 0; i < emailsToAdd.length; i++) {
            let user = { email: emailsToAdd[i] };
            let checkIfUserInList = currUsers.findIndex(object => {
                return object.email === emailsToAdd[i];
            });
            if (checkIfUserInList === -1) {
                usersToAddWithoutDuplicates.push(user);
                currUsers.push(user);
            }
        }
        this.addUsersToArea(usersToAddWithoutDuplicates);
    };

    removeUser = (user) => {
        var currUsers = this.state.areaUsers;
        currUsers.splice(currUsers.findIndex(object => {
            return object.email === user.email;
        }), 1);
        this.removeUserFromArea(user);
    };

    addUserToArea = (user) => {
        this.setState({ isLoading: true });
        addAdHocAreaUser(this.state.selectedAreaId, user).then(() => {
            toast.success(`Added ${user.email}.`)
            this.loadAreaUsers(this.props.areaId);
        }).catch((err) => {
            toast.error("There was an error updating users");
            console.error("Error", err);
            this.loadAreaUsers(this.props.areaId);
        })
    }

    addUsersToArea = (usersToAdd) => {
        this.setState({ isLoading: true });
        addAdHocAreaUsers(this.state.selectedAreaId, usersToAdd).then(() => {
            toast.success(`Added ${usersToAdd.length} users.`)
            this.closeMultiInput();
            this.loadAreaUsers(this.props.areaId);
        }).catch((err) => {
            toast.error("There was an error updating users");
            console.error("Error", err);
            this.closeMultiInput();
            this.loadAreaUsers(this.props.areaId);
        })
    }

    removeUserFromArea = (user) => {
        this.setState({ isLoading: true });
        removeAdHocAreaUser(this.state.selectedAreaId, user).then(() => {
            toast.success(`Removed ${user.email}.`)
            this.loadAreaUsers(this.props.areaId);
        }).catch((err) => {
            toast.error("There was an error updating users");
            console.error("Error", err);
            this.loadAreaUsers(this.props.areaId);
        })
    }

    generateTableBodySelected = (array) => {
        return array.map((item, index) => {
            return (
                <tr key={index} className="searchContent">
                    <td >
                        {item.email}
                    </td>
                    <td style={{ textAlign: "center", cursor: "pointer" }} onClick={() => { this.copyAdHocLink(item) }}>
                        <img
                            src={CopyLinkIcon}
                            alt="Copy link"
                            style={{ margin: "auto" }}
                        />
                    </td>
                    <td style={{ textAlign: "center", cursor: "pointer" }} onClick={() => { this.sendAdHocMailSingle(item) }}><i className="ci-icon ci-icon-ic-contact"></i></td>
                    <td style={{ textAlign: "center", cursor: "pointer" }} onClick={() => { this.removeUser(item) }}><i style={{ margin: "auto" }} className="ci-icon ci-icon-ic-close"></i></td>
                </tr>
            )
        })
    }

    adHocEmailChanged = (value) => {
        this.setState({
            adHocEmail: value
        })
    }

    copyAdHocLink = (user) => {
        let getUrl = window.location;
        let baseUrl = getUrl.protocol + "//" + getUrl.host + "/" + getUrl.pathname.split('/')[1];
        let adHocLink = baseUrl + "adhoc?id=" + user.adHocId;
        navigator.clipboard.writeText(adHocLink)
        toast.success("Link copied to clipboard.");
    }

    sendAdHocMailSingle = (user) => {
        sendAdHocUserMail(user.adHocId).then(() => {
            toast.success(`Mail sent to ${user.email}.`);
        }).catch((err) => {
            toast.error("There was an error sending the email.");
            console.error("Error", err);
        })
    }

    sendAdHocMailAll = () => {
        sendAdHocUserMailAll(this.props.areaId).then(() => {
            toast.success("Mail(s) sent.");
        }).catch((err) => {
            toast.error("There was an error sending the email(s).");
            console.error("Error", err);
        })
    }

    render() {
        return (
            <div style={{ ...this.props.style, textAlign: "left" }} className="fileExChildComponent">
                <Toaster />
                <AdHocAddMultipleUsers show={this.state.showMultiInput} handleClose={this.closeMultiInput} addMultipleUsers={this.addMultipleUsers} />
                <Break style={{ margin: "20px 0" }}>
                    <div style={{ display: "flex" }}>
                        <div style={{ marginRight: "44px" }}>
                            <img
                                src={UserManagementIcon}
                                alt="Area Content"
                                style={{ height: "2rem", position: "absolute" }}
                            />
                        </div>
                        <div>
                            User Management
                        </div>
                    </div>
                </Break>
                {this.state.areaUsers.length === 0 &&
                    <div style={{ textAlign: "center" }}>Use the the email address input field below to add users to this ad hoc area.</div>
                }
                {this.state.isLoading &&
                    <><div style={{ textAlign: "center" }}>
                        <ReactSpinner type="border" color="black" size="3" />
                    </div></>
                }
                {!this.state.isLoading && this.state.areaUsers.length > 0 &&
                    <div>
                        <table style={{ width: "100%" }}>
                            <thead>
                                <tr>
                                    <th >Email</th>
                                    <th style={{ width: "80px", textAlign: "center" }}>Copy link</th>
                                    <th style={{ width: "90px", textAlign: "center" }}>Send mail</th>
                                    <th style={{ width: "80px", textAlign: "center" }}>Remove</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.generateTableBodySelected(this.state.areaUsers)}
                            </tbody>
                        </table>
                    </div>
                }
                <React.Fragment>
                    <hr style={{ margin: "30px 0" }} />
                    <div style={{ display: "flex", justifyContent: "left", marginBottom: "12px", marginTop: '8px', alignItems: "center" }}>
                        <Input label="Email" value={this.state.adHocEmail} onClick={this.adHocEmailChanged} style={{ width: "100%", marginRight: "20px" }} />
                        <div style={{ marginLeft: "auto" }}>
                            <div style={{ display: "flex", justifyContent: "right", marginBottom: "4px" }}>
                                <span style={{ marginRight: "12px", borderRight: "1px solid rgba(0, 0, 0, 0.1)", paddingRight: "12px" }}>
                                    <Button type="hover-bottom-left" onClick={() => { this.addUser() }}>Add user</Button>
                                </span>
                                <Button type="hover-bottom-left" onClick={() => { this.openMultiInput() }}>Add multiple users</Button>
                            </div>
                        </div>
                    </div>
                    {this.state.adHocValidationError.length > 0 &&
                        <label style={{ color: "#F50506" }}>{this.state.adHocValidationError}</label>
                    }
                    {this.state.areaUsers.length > 0 &&
                        <div style={{ display: "flex", justifyContent: "right", marginBottom: "12px", marginTop: '8px' }}>
                            <Button type="hover-bottom-left" onClick={() => { this.sendAdHocMailAll() }} >Send mail to all users</Button>
                        </div>
                    }
                    
                </React.Fragment>
                <hr style={{ margin: "30px 0" }} />
            </div>

        );
    }
}
export default withRouter(AdHocUserManagement);